// import { Link } from "react-router-dom";
import { DEFAULT_CALLER_NO } from "../../../config/Constant";

const CategoryNav = () => {
  return (
    <div className="row align-items-center">
      {/* <nav>
        <ul className="d-flex list-unstyled mb-0 flex-wrap">
          <li className="me-3">
            <Link to="/">Home</Link>
          </li>
          <li className="me-3">
            <Link to="/grocery">Grocery</Link>
          </li>
          <li className="me-3">
            <Link to="/furniture">Furniture</Link>
          </li>
          <li className="me-3">
            <Link to="/clothing">Clothing</Link>
          </li>
          <li className="me-3">
            <Link to="/electronics">Electronics</Link>
          </li>
        </ul>
      </nav> */}
      {/* ENTIRE BAR (Phone + Social) */}
      <div className="col-12 d-flex flex-row justify-content-center justify-content-lg-between align-items-center py-1 py-lg-2 m-0 px-0">
        {/* Contact details (Phone) */}
        <div className="d-flex align-items-center">
          <div
            className="d-flex align-items-center justify-content-center bg-white rounded-circle me-1 me-sm-2"
            style={{ width: "22px", height: "22px", minWidth: "22px" }}
          >
            <i
              className="fas fa-phone-alt"
              style={{ color: "#00a650", fontSize: "10px" }}
            ></i>
          </div>
          <a
            href={`tel:${DEFAULT_CALLER_NO}`}
            className="mb-0 text-white fw-bold text-decoration-none"
            style={{ fontSize: "13px", letterSpacing: "0.2px" }}
          >
            {DEFAULT_CALLER_NO}
          </a>
        </div>

        {/* Vertical Divider - ONLY VISIBLE ON MOBILE */}
        <div
          style={{
            width: "1px",
            height: "18px",
            backgroundColor: "rgba(255,255,255,0.6)",
          }}
          className="mx-2 mx-sm-3 d-lg-none"
        ></div>

        {/* Social icons */}
        <div className="d-flex align-items-center">
          <a
            href="/"
            className="text-white text-decoration-none d-flex align-items-center justify-content-center"
            title="Facebook"
          >
            <i className="fab fa-facebook-f" style={{ fontSize: "14px" }}></i>
          </a>

          {/* Vertical Divider */}
          <div
            style={{
              width: "1px",
              height: "18px",
              backgroundColor: "rgba(255,255,255,0.6)",
            }}
            className="mx-2 mx-sm-3"
          ></div>

          <a
            href="/"
            className="text-white text-decoration-none d-flex align-items-center justify-content-center"
            title="Instagram"
          >
            <i className="fab fa-instagram" style={{ fontSize: "15px" }}></i>
          </a>

          {/* Vertical Divider */}
          <div
            style={{
              width: "1px",
              height: "18px",
              backgroundColor: "rgba(255,255,255,0.6)",
            }}
            className="mx-2 mx-sm-3"
          ></div>

          <a
            href="/"
            className="text-white text-decoration-none d-flex align-items-center justify-content-center"
            title="LinkedIn"
          >
            <i className="fab fa-linkedin-in" style={{ fontSize: "15px" }}></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default CategoryNav;
